import { bl_sfa_attachment_RowClass } from "../../../dbschema/bl_sfa_attachment.model";
import { BaseContainerModel } from "../../base-container.model";

export class SfaAttachmentContainerModel extends BaseContainerModel {
    bl_sfa_attachment: bl_sfa_attachment_RowClass = new bl_sfa_attachment_RowClass();
}